export default function addFilterQueryWithCondition(filter, pool = {}, parent = '') {
  const filterData = Object.entries(filter).reduce((prev, current = []) => {
    const [name, value] = current;
    const currentName = `${parent}${name}`;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      const data = addFilterQueryWithCondition(value, {}, `${currentName}_`);
      Object.keys(data).forEach(key => {
        prev[key] = data[key];
      });
    } else if (typeof value !== 'undefined' && value !== null && String(value).length) {
      prev[currentName] = value;
    }
    return prev;
  }, {});
  return { ...pool, ...filterData };
}
